import { z } from "zod";

export const schema = z.object({
  label: z.string().min(1, "Label is required"),
});
